// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Belt_List from "bs-platform/lib/es6/belt_List.js";
import * as Belt_Array from "bs-platform/lib/es6/belt_Array.js";
import * as ReactDOMRe from "reason-react/src/ReactDOMRe.js";
import * as Belt_Option from "bs-platform/lib/es6/belt_Option.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as ReasonReact from "reason-react/src/ReasonReact.js";
import * as Utils$SystemaFr from "../utils/Utils";
import * as Layout$SystemaFr from "../components/Layout";
import * as Leaflet$SystemaFr from "../utils/Leaflet";
import * as ReasonReactRouter from "reason-react/src/ReasonReactRouter.js";
import * as Scripts$SystemaFr from "../utils/Scripts";
import * as Markdown$SystemaFr from "../components/Markdown";
import * as ObfuscatedLink$SystemaFr from "../components/ObfuscatedLink";

import "../assets/css/join.css"
;

var noSeminarView = React.createElement("div", {
      className: "no-content-placeholder mdl-grid",
      style: Utils$SystemaFr.style(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "50px 0", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* () */0)
    }, React.createElement("div", {
          className: "mdl-cell mdl-cell--12-col"
        }, React.createElement("div", {
              className: "material-icons md-dark"
            }, Utils$SystemaFr.text("event_busy")), React.createElement("br", undefined), React.createElement("em", undefined, Utils$SystemaFr.text("Pas de stage prévu pour le moment"))));

function instructorView(instructor) {
  var optionalTitle = Utils$SystemaFr.optionalView(instructor.title, Utils$SystemaFr.text);
  var optionalDescription = Utils$SystemaFr.optionalView(instructor.description, (function ($$document) {
          return React.createElement("div", {
                      className: "mdl-card__supporting-text"
                    }, ReasonReact.element(undefined, undefined, Markdown$SystemaFr.make(undefined, $$document, [])));
        }));
  var optionalCertificate = Utils$SystemaFr.optionalView(instructor.certificate, (function (certificate) {
          return React.createElement("div", undefined, React.createElement("a", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect",
                          href: ""
                        }, React.createElement("div", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("stars"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text(certificate));
        }));
  var optionalPhone = Utils$SystemaFr.optionalView(instructor.phone, (function (phone) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("phone"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, ReasonReact.element(undefined, undefined, ObfuscatedLink$SystemaFr.make(undefined, undefined, undefined, "tel:" + phone, phone, [])));
        }));
  var optionalEmail = Utils$SystemaFr.optionalView(instructor.email, (function (email) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("email"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, ReasonReact.element(undefined, undefined, ObfuscatedLink$SystemaFr.make(undefined, undefined, undefined, "mailto:" + email, email, [])));
        }));
  var photoStyle = Utils$SystemaFr.style(undefined, $$String.concat("", /* :: */[
            "url('",
            /* :: */[
              instructor.photo,
              /* :: */[
                "') center / cover",
                /* [] */0
              ]
            ]
          ]), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* () */0);
  return React.createElement("div", {
              key: instructor.id,
              className: "mdl-cell mdl-cell--4-col"
            }, React.createElement("div", {
                  className: "mdl-shadow--2dp instructor-card mdl-card"
                }, React.createElement("div", {
                      className: "mdl-card__title",
                      style: photoStyle
                    }, React.createElement("h2", {
                          className: "mdl-card__title-text"
                        }, Utils$SystemaFr.text(instructor.name), React.createElement("br", undefined), optionalTitle)), optionalDescription, React.createElement("div", {
                      className: "mdl-card__actions mdl-card--border"
                    }, optionalCertificate, optionalPhone, optionalEmail)));
}

function locationView($$location) {
  var optionalDescription = Utils$SystemaFr.optionalView($$location.description, (function (description) {
          return React.createElement("div", {
                      className: "mdl-card__supporting-text"
                    }, ReasonReact.element(undefined, undefined, Markdown$SystemaFr.make(undefined, description, [])));
        }));
  var timetable = Belt_Array.mapWithIndex($$location.timetable.split("\n"), (function (index, time) {
          return React.createElement("div", {
                      key: $$String.concat("", /* :: */[
                            $$location.id,
                            /* :: */[
                              "-time-",
                              /* :: */[
                                String(index),
                                /* [] */0
                              ]
                            ]
                          ])
                    }, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text(index === 0 ? "schedule" : "null"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, React.createElement("strong", undefined, Utils$SystemaFr.text(time)));
        }));
  var optionalInstructor = Utils$SystemaFr.optionalView($$location.instructor, (function (instructor) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("schoolb"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, React.createElement("strong", undefined, Utils$SystemaFr.text(instructor)));
        }));
  var address = Belt_Array.mapWithIndex($$location.address.split("\n"), (function (index, line) {
          return React.createElement("div", {
                      key: $$String.concat("", /* :: */[
                            $$location.id,
                            /* :: */[
                              "-address-line-",
                              /* :: */[
                                String(index),
                                /* [] */0
                              ]
                            ]
                          ])
                    }, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text(index === 0 ? "room" : "null"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text(line));
        }));
  var optionalTrain = Utils$SystemaFr.optionalView($$location.train, (function (train) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("directions_subway"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text(train));
        }));
  var optionalFeeDetails = Utils$SystemaFr.optionalView($$location.feeDetails, (function (feeDetails) {
          return React.createElement("div", {
                      className: "white-popup mfp-hide zoom-anim-dialog",
                      id: $$location.id + "-fees-popup"
                    }, ReasonReact.element(undefined, undefined, Markdown$SystemaFr.make(undefined, feeDetails, [])));
        }));
  var optionalFee = Utils$SystemaFr.optionalView($$location.fee, (function (fee) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, Utils$SystemaFr.text("€")), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text(fee), Belt_Option.isNone($$location.feeDetails) ? Utils$SystemaFr.$$null : React.createElement("a", {
                            className: "open-popup-link",
                            href: "#" + ($$location.id + "-fees-popup")
                          }, Utils$SystemaFr.text(" Voir tarifs")));
        }));
  var optionalFiles = Belt_List.toArray(Belt_List.map($$location.documents, (function (param) {
              var publicURL = param.publicURL;
              var name = param.name;
              return React.createElement("div", {
                          key: $$location.id + name
                        }, React.createElement("span", {
                              className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                            }, React.createElement("span", {
                                  className: "material-icons md-dark"
                                }, Utils$SystemaFr.text("attach_file"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, React.createElement("a", {
                              key: publicURL,
                              href: publicURL
                            }, Utils$SystemaFr.text(name)));
            })));
  var optionalPhone = Utils$SystemaFr.optionalView($$location.phone, (function (phone) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("phone"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text("Tél : "), ReasonReact.element(undefined, undefined, ObfuscatedLink$SystemaFr.make(undefined, undefined, undefined, "tel:" + phone, phone, [])));
        }));
  var optionalEmail = Utils$SystemaFr.optionalView($$location.email, (function (email) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("email"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text("E-mail : "), ReasonReact.element(undefined, undefined, ObfuscatedLink$SystemaFr.make(undefined, undefined, undefined, "mailto:" + email, email, [])));
        }));
  var optionalInfo = Utils$SystemaFr.optionalView($$location.info, (function (info) {
          return React.createElement("div", undefined, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("info"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, Utils$SystemaFr.text("Infos : "), Utils$SystemaFr.text(info));
        }));
  return React.createElement("div", {
              key: $$location.id,
              className: "mdl-cell mdl-cell--4-col"
            }, React.createElement("div", {
                  className: "location-card mdl-card mdl-shadow--2dp"
                }, React.createElement("div", {
                      className: "mdl-card__title"
                    }, React.createElement("h2", {
                          className: "mdl-card__title-text"
                        }, Utils$SystemaFr.text($$location.name))), optionalDescription, React.createElement("div", {
                      className: "mdl-card__actions mdl-card--border"
                    }, timetable, optionalInstructor, address, optionalTrain, optionalFee, optionalFeeDetails, optionalFiles, optionalPhone, optionalEmail, optionalInfo)));
}

function regionView(info, tabClass, region, locations) {
  var match = region.coordinates;
  return React.createElement("div", {
              key: "regionViewKey-" + region.id,
              className: "mdl-tabs__panel" + tabClass,
              id: region.id + "Tab"
            }, React.createElement("div", {
                  className: "mdl-grid"
                }, React.createElement("div", {
                      className: "mdl-cell mdl-cell--12-col"
                    }), React.createElement("div", {
                      className: "mdl-cell mdl-cell--12-col"
                    }, React.createElement("span", {
                          className: "mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect"
                        }, React.createElement("span", {
                              className: "material-icons md-dark"
                            }, Utils$SystemaFr.text("info_outline"))), Utils$SystemaFr.nbsp, Utils$SystemaFr.nbsp, ReasonReact.element(undefined, undefined, Markdown$SystemaFr.make("join-info", info, []))), Belt_List.toArray(Belt_List.map(locations, locationView))), match !== undefined ? React.createElement("div", {
                    className: "heroin-map-section",
                    id: "map-systema-" + region.id
                  }) : Utils$SystemaFr.$$null);
}

var component = ReasonReact.reducerComponent("Join");

function make(data, _children) {
  var pageUrl = ReasonReactRouter.dangerouslyGetInitialUrl(/* () */0);
  data.page.html;
  var regions = Belt_Array.map(data.regions.edges, (function (region) {
          var node = region.node;
          var frontmatter = node.frontmatter;
          var match = frontmatter.longitude;
          var match$1 = frontmatter.latitude;
          var coordinates = !(match == null) && !(match$1 == null) ? /* tuple */[
              match,
              match$1
            ] : undefined;
          return {
                  id: frontmatter.id,
                  name: frontmatter.title,
                  description: Utils$SystemaFr.optionalTextObj(node.rawMarkdownBody, node.html),
                  coordinates: coordinates
                };
        }));
  var locations = Belt_List.map(Belt_List.fromArray(data.locations.edges), (function ($$location) {
          var node = $$location.node;
          var frontmatter = node.frontmatter;
          var match = frontmatter.document;
          var documents = (match == null) ? /* [] */0 : /* :: */[
              {
                name: match.name,
                publicURL: match.publicURL
              },
              /* [] */0
            ];
          return {
                  id: node.id,
                  name: frontmatter.title,
                  region: frontmatter.region,
                  description: Utils$SystemaFr.optionalTextObj(node.rawMarkdownBody, node.html),
                  timetable: frontmatter.timetable,
                  instructor: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.instructor)),
                  address: frontmatter.address,
                  train: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.train)),
                  fee: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.fee)),
                  feeDetails: Belt_Option.map(Caml_option.nullable_to_opt(frontmatter.feeDetails), (function (feeDetails) {
                          return feeDetails.childMarkdownRemark.html;
                        })),
                  documents: documents,
                  phone: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.phone)),
                  email: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.email)),
                  info: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.information)),
                  index: frontmatter.index,
                  longitude: Caml_option.nullable_to_opt(frontmatter.longitude),
                  latitude: Caml_option.nullable_to_opt(frontmatter.latitude)
                };
        }));
  Belt_List.map(Belt_List.fromArray(data.instructors.edges), (function (instructor) {
          var node = instructor.node;
          var frontmatter = node.frontmatter;
          return {
                  id: node.id,
                  name: node.frontmatter.title,
                  title: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.position)),
                  description: Utils$SystemaFr.optionalTextObj(node.rawMarkdownBody, node.html),
                  certificate: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.certificate)),
                  phone: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.phone)),
                  email: Utils$SystemaFr.filterEmptyText(Caml_option.nullable_to_opt(frontmatter.email)),
                  photo: frontmatter.image.publicURL,
                  index: frontmatter.index
                };
        }));
  var mapMarkers = Belt_List.toArray(Belt_List.reduce(locations, /* [] */0, (function (acc, $$location) {
              var match = $$location.longitude;
              var match$1 = $$location.latitude;
              if (match !== undefined && match$1 !== undefined) {
                var latitude = match$1;
                var longitude = match;
                if (longitude !== 0.0 && latitude !== 0.0) {
                  return /* :: */[
                          /* tuple */[
                            $$location.name,
                            longitude,
                            latitude
                          ],
                          acc
                        ];
                } else {
                  return acc;
                }
              } else {
                return acc;
              }
            })));
  var mapElements = Belt_Array.reduce(regions, /* [] */0, (function (acc, region) {
          var match = region.coordinates;
          if (match !== undefined) {
            var mapElement = ReasonReact.element("mapKey-" + region.id, undefined, Leaflet$SystemaFr.$$Map.make(match, "heroin-map-section", /* Zoom */0, undefined, 13, [
                      ReasonReact.element(undefined, undefined, Leaflet$SystemaFr.TileLayer.make(Curry._2(Leaflet$SystemaFr.Providers.Mapbox.url, undefined, "pk.eyJ1IjoibXZlbmF0b3IiLCJhIjoiY2lmMWI2cGhxMDBnbXRsbHlkdmgzZTlhZyJ9.y75wBt4ZuWDyDnPtq1JXGQ"), Leaflet$SystemaFr.Providers.Mapbox.attribution, undefined, undefined, [])),
                      Belt_Array.map(mapMarkers, (function (param) {
                              var name = param[0];
                              return ReasonReact.element("mapMarkerKey-" + name, undefined, Leaflet$SystemaFr.Marker.make(/* tuple */[
                                              param[1],
                                              param[2]
                                            ], undefined, undefined, undefined, undefined, [ReasonReact.element(undefined, undefined, Leaflet$SystemaFr.Popup.make(undefined, undefined, undefined, undefined, undefined, [Utils$SystemaFr.text(name)]))]));
                            }))
                    ]));
            return /* :: */[
                    /* tuple */[
                      region.id,
                      mapElement
                    ],
                    acc
                  ];
          } else {
            return acc;
          }
        }));
  var regionId = pageUrl.hash;
  var initialTab;
  if (regionId === "instructors") {
    initialTab = /* Static */0;
  } else {
    var regionList = Belt_List.fromArray(regions);
    initialTab = Belt_List.has(regionList, regionId, (function (region, id) {
            return region.id === id;
          })) ? /* WithMap */[regionId] : /* WithMap */["paris"];
  }
  return {
          debugName: component.debugName,
          reactClassInternal: component.reactClassInternal,
          handedOffState: component.handedOffState,
          willReceiveProps: component.willReceiveProps,
          didMount: (function (self) {
              Curry._1(Scripts$SystemaFr.Mdl.initializeTabs, /* () */0);
              Curry._1(Scripts$SystemaFr.MagnificPopup.initializePopups, /* () */0);
              var tab = self.state.tab;
              if (tab) {
                var regionId = tab[0];
                var match = Belt_List.getAssoc(mapElements, regionId, (function (prim, prim$1) {
                        return prim === prim$1;
                      }));
                if (match !== undefined) {
                  return ReactDOMRe.renderToElementWithId(Caml_option.valFromOption(match), "map-systema-" + regionId);
                } else {
                  return /* () */0;
                }
              } else {
                return /* () */0;
              }
            }),
          didUpdate: component.didUpdate,
          willUnmount: component.willUnmount,
          willUpdate: component.willUpdate,
          shouldUpdate: component.shouldUpdate,
          render: (function (self) {
              var year = Curry._1(Utils$SystemaFr.$$Date.year, /* () */0);
              var form_years = Curry._1(Utils$SystemaFr.$$Date.month, /* () */0) < 7 ? String(year - 1 | 0) + ("-" + String(year)) : String(year) + ("-" + String(year + 1 | 0));
              return ReasonReact.element(undefined, undefined, Layout$SystemaFr.make("Inscription", "join-layout", [React.createElement("div", {
                                    className: "content"
                                  }, React.createElement("iframe", {
                                        height: "1024px",
                                        src: "https://framaforms.org/systema-salle-darmes-" + (form_years + "-1632219210"),
                                        width: "100%"
                                      }))]));
            }),
          initialState: (function (param) {
              return {
                      tab: initialTab
                    };
            }),
          retainedProps: component.retainedProps,
          reducer: (function (action, state) {
              return /* Update */Block.__(0, [{
                          tab: action[0]
                        }]);
            }),
          jsElementWrapped: component.jsElementWrapped
        };
}

var $$default = ReasonReact.wrapReasonForJs(component, (function (jsProps) {
        return make(jsProps.data, jsProps.children);
      }));

export {
  noSeminarView ,
  instructorView ,
  locationView ,
  regionView ,
  component ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
